// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LiliButton } from '@lili/lili-frontend-common';
import Heading from '../../../generic-components/Heading';
import { getAnalyticsFlowName, IntroContentMap, IntroLogoMap, MoveMoneySteps, MoveMoneyTypes } from '../consts';
import Icon from '../../../generic-components/Icon';
import { useStore } from '../../../store';
import { trackMixPanel } from '../../../services/mixpanel.service';

export const MoveMoneyIntroStep = () => {
  const { moveType } = useParams();
  const { t } = useTranslation();

  const moveMoneyData = useStore((state) => state.moveMoneyData);
  const setMoveMoneyData = useStore((state) => state.setMoveMoneyData);

  const handleGetStarted = () => {
    trackMixPanel('Act on Move Money Intro Screen', {
      Action: 'Let’s Start',
      Flow: getAnalyticsFlowName(moveType as MoveMoneyTypes),
    });
    if (moveMoneyData.supplierList.length) {
      setMoveMoneyData({ ...moveMoneyData, activeStepId: MoveMoneySteps.VENDOR_PICKER });
    } else {
      setMoveMoneyData({ ...moveMoneyData, activeStepId: MoveMoneySteps.VENDOR_UPDATE });
    }
  };

  const getDynamicIconSrc = () => IntroLogoMap[moveType as keyof typeof IntroLogoMap];

  const getDynamicContent = () => IntroContentMap[moveType as keyof typeof IntroContentMap];

  useEffect(() => {
    trackMixPanel('View Move Money Intro Screen', { Origin: 'Menu' });
  }, []);

  return (
    <div className='flex flex-col w-full h-full pb-[38px]'>
      <h1 className='font-metricRMedium text-[28px] mb-[24px] text-bw08'>{t(getDynamicContent().main_header)}</h1>
      <div className='flex relative flex-col h-full items-center justify-center bg-bw00 rounded-md shadow-light'>
        <Icon className='mb-[32px]' src={getDynamicIconSrc()} />
        <Heading title={t(getDynamicContent().title)} className='font-metricRMedium text-[24px] text-bw08 mb-[16px]' />
        <Heading
          title={t(getDynamicContent().content)}
          className='font-metricR text-[16px] text-bw07 mb-[32px] text-center max-w-[380px]'
        />
        {getDynamicContent().fee_data && (
          <Heading
            title={t(getDynamicContent().fee_data)}
            className='font-metricR text-[16px] text-bw07 mb-[32px] text-center max-w-[380px]'
          />
        )}
        <LiliButton
          className='w-[240px]'
          onClick={handleGetStarted}
          id='getStarted'
          title={t('MOVE_MONEY.STEPS.INTRO.MAIN_CTA')}
        />
        {getDynamicContent().disclaimer && (
          <div className='absolute left-0 bottom-0 w-full py-[12px] border-t border-bw03 flex items-center justify-center'>
            <Heading
              title={t(getDynamicContent().disclaimer)}
              className='font-metricR text-[14px] max-w-[660px] text-bw07 text-center'
            />
          </div>
        )}
      </div>
    </div>
  );
};
